module.exports = __webpack_public_path__ + "img/2.b9c515c6.jpg";